/* eslint-disable no-undef */
export default {
	name: "select-shipping-address-for-order-modal",
	props: ["customer", "showModal"],
	emits: ["shippingAddressSelected"],
	data() {
		return {
			company: {},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filter:{
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			orderTotal: 0,
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: "Select Shipping Address For Order",
			modalComponentId: "selectShippingAddressForOrderModal",
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		onShippingAddressSelected(shippingAddress){
			this.$emit("shippingAddressSelected", shippingAddress);
		}
	},
	mounted: function () {
	},
	watch:{
		showModal: {
			handler: function (){
				console.log("showModal", this.showModal);
				if(this.showModal){
					$("#" + this.modalComponentId).modal("show");
				}
				else{
					$("#" + this.modalComponentId).modal("hide");
				}
			}
		},
		customer:{
			handler: function(){
				if(this.customer !== null){
					this.company = this.customer;
					console.log("company", this.company);
				}
			}
		}
	}
};
